// extracted by mini-css-extract-plugin
export default {"container":"u0-z","heading":"v0-z","links":"w0-z","copy":"x0-z","subCopy":"y0-z","linksLeft":"z0-z","linksCenter":"A0-z","linksRight":"B0-z","link":"C0-z","onlyLink":"D0-z"};